import { InfoLabel, PopoverProps } from '@fluentui/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountAmountStyles } from '../../../hooks/useAccountAmountStyles';

interface ILastModifiedByIconProps {
    lastModifiedBy: string | null;
}

export const LastModifiedByIcon: FC<ILastModifiedByIconProps> = ({ lastModifiedBy }) => {
    const styles = useAccountAmountStyles();
    const { t } = useTranslation();
    return (
        <InfoLabel
            info={
                <>
                    <div style={{ fontWeight: 600, fontSize: 10 }}>{t('lastModifiedBy')}:</div>{' '}
                    <div style={{ fontWeight: 400, fontSize: 10 }}>{lastModifiedBy}</div>
                </>
            }
            infoButton={{
                size: 'small',
                popover: {
                    appearance: 'inverted',
                    size: 'small',
                    withArrow: true,
                    positioning: 'below',
                } as PopoverProps,
                inline: false,
                className: styles.infoIcon,
            }}
            aria-label={t('lastModifiedByCalloutButtonLabel')?.toString()}
        ></InfoLabel>
    );
};
